<!--
 * @Description: 
 * @version: 1.0.0
 * @Author: zhangxin
 * @Date: 2021-04-14 14:17:11
 * @LastEditors: youqixin
 * @LastEditTime: 2021-04-14 14:45:58
-->
<template>
  <div class="login-self">
    <el-dialog
      width="554px"
      :visible.sync="modelShow"
      center
      custom-class="test-one"
    >
      <div slot="title" class="login-title">账号登录</div>
      <div class="login-in">
        <div>
          <input type="number" v-model="phone" placeholder="请输入手机号" />
        </div>
        <div class="login-code">
          <div class="login-code-one">
            <input type="text" v-model="code" placeholder="验证码" />
          </div>
          <div v-show="!showTimer" class="login-send" v-on:click="sendMessage">
            发送验证码
          </div>
          <div v-show="showTimer" class="login-send-wait">{{ time }}s</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="login-sub" v-on:click="doLogin(sendcode)">登录</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      time: 60,
      showTimer: false,
      sendcode: false,
      phone: "",
      code: "",
      //是否显示本面板
      modelShow: true,
      //是否可以关闭
      canClose: false,
      //表单数据
      form: {
        id: "",
        pw: "",
      },
    };
  },
  mounted() {
    // const that = this;
    // //如果用户没有登录，则打开登录界面
    // if (window.sessionStorage) {
    //   const data = JSON.parse(sessionStorage.getItem("is_login"));
    //   if (data) {
    //     that.modelShow = false;
    //   } else {
    //     that.modelShow = true;
    //   }
    // }
  },
  methods: {
    lodaTime() {
      let timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(timer);
          this.showTimer = false;
          this.time = 60;
        } else {
          this.time--;
        }
      }, 1000);
    },
    sendMessage() {
      // console.log(this.phone);
      let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!reg.test(this.phone)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号!",
        });
        return false;
      } else {
        console.log("");
      }

      // this.sendcode = true;151
      // this.showTimer = true;
      // this.lodaTime();
      this.api
        .get("/identity/v1/Login/smscode", { mobile: this.phone })
        .then(() => {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
          this.sendcode = true;
          this.showTimer = true;
          this.lodaTime();
        });
    },
    //登录
    doLogin: function () {
      // if (!val) {
      //   return false;
      // }
      let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (this.code == null || this.code == "") {
        this.$message({
          type: "error",
          message: "请输入正确的验证码!",
        });
        return false;
      } else if (!reg.test(this.phone)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号!",
        });
        return false;
      } else {
        console.log("");
      }
      let params = {
        mobile: this.phone,
        code: this.code,
        clientId: "xilife.xdp.xshop.login",
      };
      this.api.post("/identity/v1/Login/smscode", params).then((res) => {
        this.$message({
          type: "success",
          message: "登陆成功!",
        });
        this.modelShow = false;
        localStorage.setItem("users.access_token", res.data.access_token);
        localStorage.setItem("users.refresh_token", res.data.refresh_token);
        window.location.reload();
      });
    },
    test() {},
    //关闭登录窗口前的回调(如果用户没有登录成功，则再次打开本窗口，以达到强制登录的目的)
    closeCallback: function () {
      if (window.sessionStorage) {
        const data = JSON.parse(sessionStorage.getItem("is_login"));
        if (data) {
          this.modelShow = false;
        } else {
          this.modelShow = true;
        }
      }
    },
  },
};
</script>
<style lang="less">
.login-self {
  .test-one {
    // background:red !important;
  }
}
</style>
<style lang="less" scoped>
.login-in {
  text-align: center;
  // margin:0 117px;
}
input {
  outline-color: transparent;
  box-shadow: none;
  outline-style: none;
  outline-width: 0px;
  background: #f5f5f5;
  border: 1px solid #cccccc;
  border-radius: 3px;
  width: 280px;
  height: 48px;
  text-indent: 15px;
}
.login-code-one {
  display: inline-block;
  input {
    width: 139px;
  }
}
.login-code {
  margin-top: 30px;
}
.login-send {
  cursor: pointer;
  display: inline-block;
  background: #333333;
  border-radius: 3px;
  line-height: 48px;
  width: 126px;
  color: #fff;
  border: 1px solid #333333;
  margin-left: 15px;
}
.login-send-wait {
  cursor: pointer;
  display: inline-block;
  background: #ccc;
  border-radius: 3px;
  line-height: 48px;
  width: 126px;
  color: #fff;
  border: 1px solid #ccc;
  margin-left: 15px;
}
.login-sub {
  cursor: pointer;
  display: inline-block;
  background: #333333;
  border-radius: 3px;
  line-height: 48px;
  width: 280px;
  color: #fff;
  border: 1px solid #333333;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 25px;
}
.disColor {
  border: 1px solid #cccccc;
  background: #cccccc;
}
.login-title {
  font-size: 26px;
  color: #333333;
  margin-top: 20px;
  font-weight: bold;
}
</style>
